<template>
	<component
		:is="PageComponent"
		v-if="PageComponent"
		:slug="slug"
		:unique-product-name="slug"
	/>
</template>

<script setup lang="ts">
import { shallowRef, defineAsyncComponent } from "vue";
import type { Component } from "vue";

const route = useRoute();
const { resolveSlug } = useNorcePwa();
const { localeProperties } = useI18n();
const rawSlug = Array.isArray(route.params.slug)
	? route.params.slug.join("/")
	: route.params.slug || "";
const slug = encodeURIComponent(rawSlug);
const { data, error } = await useAsyncData(
	`resolveSlug-${slug}`,
	() =>
		resolveSlug({
			slug: slug as string,
			cultureCode: localeProperties.value.iso as string
		}),
	{
		lazy: false
	}
);
const type = (data.value?.type as string) || "";
if (error.value) {
	console.error("Error resolving slug:", error.value);
}

if (type === "redirect") {
	const targetPath = data.value?.targetPath;
	// A redirect entry without a target must not become a silent redirect to
	// the homepage (navigateTo(undefined) falls back to "/") — fall through
	// and render the slug as a CMS page instead.
	if (targetPath) {
		await navigateTo(targetPath, {
			redirectCode: data.value?.redirectType || 302
		});
	}
}

const PageComponent = shallowRef<Component | null>(null);
if (type === "product") {
	PageComponent.value = defineAsyncComponent(
		() => import("./product/[uniqueProductName]/index.vue")
	);
} else if (type === "category") {
	PageComponent.value = defineAsyncComponent(
		() => import("./category/[...slug].vue")
	);
} else if (type !== "redirect") {
	PageComponent.value = defineAsyncComponent(
		() => import("./cms/[...slug].vue")
	);
}
</script>
